import { parsePhoneNumber } from 'libphonenumber-js';

export function isNumberValid(phoneNumber: string): boolean {
  if (!phoneNumber) return true;

  try {
    const phone = parsePhoneNumber(phoneNumber, 'US');
    return phone && phone.isValid();
  } catch (e) {
    return false;
  }
}
